export enum ServiceRequestStatusesByDate {
  /** Заявка выполнена в срок */
  COMPLETED_ON_TIME = 'completedOnTime',

  /** Заявка выполнена, но не завершена (не закрыта) */
  COMPLETED_NOT_CLOSED = 'completedButNotClosed',

  /** Заявка в работе */
  IN_PROGRESS = 'inProgress',

  /** До срока завершения заявки осталось менее 14 дней */
  DEADLINE_SOON = 'lessThan14DaysToDeadline',

  /** Срок завершения заявки просрочен */
  DEADLINE_OVERDUE = 'deadlineOverdue',
}

export const ServiceRequestStatusesByDateLabels: Record<ServiceRequestStatusesByDate, string> = {
  [ServiceRequestStatusesByDate.COMPLETED_ON_TIME]: 'Заявка завершена в срок',
  [ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED]: 'Выполнена, но не завершена',
  [ServiceRequestStatusesByDate.IN_PROGRESS]: 'Заявка в работе',
  [ServiceRequestStatusesByDate.DEADLINE_SOON]: 'До срока завершения менее 14 дней',
  [ServiceRequestStatusesByDate.DEADLINE_OVERDUE]: 'Срок завершения просрочен',
};

export const ServiceRequestStatusesByDateColors: Record<ServiceRequestStatusesByDate, string> = {
  [ServiceRequestStatusesByDate.COMPLETED_ON_TIME]: '#C64CFF',
  [ServiceRequestStatusesByDate.COMPLETED_NOT_CLOSED]: '#0d99ff',
  [ServiceRequestStatusesByDate.IN_PROGRESS]: '#3AC977',
  [ServiceRequestStatusesByDate.DEADLINE_SOON]: '#FF9F00',
  [ServiceRequestStatusesByDate.DEADLINE_OVERDUE]: '#ff5e5e',
};
